import {
  wxhDetail,
  wxhDetailEdit,
  wxhDetailEdit2,
  getWxhCategoryProperties,
  wxhBatchUpdateCategory,
  getWxhBrandValidList,
  saveBatchTempConf,
  queryWxsphBatchProductList,
  wxhBatchUpdate,
  wxsphBatchUpdateSku,
  batchPublishItem,
  applyToOtherShop,
  batchBrandFill,
  editWxhCarouselVideo,
} from '@/api/prod/center'
import store from '@/store'

// 过滤上传失败或为空的图片
export function _filterInvalidImg(imgsArr) {
  return imgsArr.filter(img => {
    if (!img) {
      return false
    } else if (typeof img === 'object') {
      return false
    } else {
      return true
    }
  })
}
/**
 * 智能地址处理方法（兼容JSON字符串格式）
 * @param {Array} items - 待处理的数据项数组
 * @returns {Array} 标准化的地址信息数组
 */
export function processAddressItems(items) {
  // 安全JSON解析方法 
  const safeJsonParse = (str) => {
    if (str == null) return null;
    
    try {
      return typeof str === 'string' ? JSON.parse(str)  : str;
    } catch (e) {
      console.warn(' 地址JSON解析失败:', e.message,  '原始数据:', str);
      return str; // 解析失败返回原始值 
    }
  };
 
  // 智能地址解析函数 
  const parseAddress = (addressData) => {
    if (addressData == null) return '';
    
    // 尝试解析可能存在的JSON字符串
    const parsedData = safeJsonParse(addressData);
    
    // 已经是字符串类型直接返回 
    if (typeof parsedData === 'string') return parsedData;
    
    // 处理对象类型地址数据 
    if (parsedData && typeof parsedData === 'object') {
      // 兼容多种命名格式的字段获取 
      const getFieldValue = (obj, keys) => {
        for (const key of keys) {
          if (obj[key] != null) return obj[key];
        }
        return '';
      };
      
      // 省市区详细地址的可能字段名 
      const province = getFieldValue(parsedData, ['provinceName', 'province_name', 'province']);
      const city = getFieldValue(parsedData, ['cityName', 'city_name', 'city']);
      const county = getFieldValue(parsedData, ['countyName', 'county_name', 'county', 'district']);
      const detail = getFieldValue(parsedData, ['detailInfo', 'detail_info', 'addressDetail', 'detail']);
      
      // 拼接地址并过滤空值
      return [province, city, county, detail]
        .filter(part => part != null && part !== '')
        .join('');
    }
    
    // 其他类型转换为字符串
    return String(parsedData);
  };
 
  return items.map(item  => {
    try {
      const newItem = { ...item };
      
      // 智能地址解析策略 
      if (newItem.addressName  != null) {
        newItem.addressName  = parseAddress(newItem.addressName); 
      } else if (newItem.addressInfo  != null) {
        newItem.addressName  = parseAddress(newItem.addressInfo); 
      } else {
        newItem.addressName  = '';
        console.warn(' 地址数据缺失', `店铺ID: ${item.shopId}`); 
      }
      
      return {
        addressId: newItem.addressId  || '',
        addressName: newItem.addressName, 
        shopId: newItem.shopId  || 0
      };
    } catch (e) {
      console.error(' 处理地址项时出错:', e);
      return {
        addressId: item.addressId  || '',
        addressName: '[地址解析错误]',
        shopId: item.shopId  || 0 
      };
    }
  });
}
// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      return isRequest ? {
        ...item,
        skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
      } : {
        ...item,
        skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
      }
    })
  }

  return isRequest ? {
    ...r,
    descInfo: JSON.stringify(r.descInfo ? _filterInvalidImg(r.descInfo) : []),
    headImgs: JSON.stringify(r.headImgs ? _filterInvalidImg(r.headImgs) : []),
    productQuaInfos: JSON.stringify(r.productQuaInfos ? r.productQuaInfos : []),
    shippingInfo: JSON.stringify(r.shippingInfo ? r.shippingInfo : {}),
    specificationNames: JSON.stringify(r.specificationNames ? r.specificationNames : []),
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    productFormat: JSON.stringify(r.productFormat ? r.productFormat : []),
    brandConfig: JSON.stringify(r.brandConfig ? r.brandConfig : []),
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : ''
  } : {
    ...r,
    descInfo: r.descInfo ? JSON.parse(r.descInfo) : [],
    headImgs: r.headImgs ? JSON.parse(r.headImgs) : [],
    productQuaInfos: r.productQuaInfos ? JSON.parse(r.productQuaInfos) : [],
    shippingInfo: r.shippingInfo ? JSON.parse(r.shippingInfo) : {},
    specificationNames: r.specificationNames ? JSON.parse(r.specificationNames) : [],
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    productFormat: r.productFormat ? JSON.parse(r.productFormat) : [],
    afterSaleAddressConfig: r.afterSaleAddressConfig ? processAddressItems(JSON.parse(r.afterSaleAddressConfig) || []): [],
    brandConfig: r.brandConfig ? JSON.parse(r.brandConfig) : [],
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
  }
}

// 编辑详情
export function editWxhDetail(data) {
  if (data.preSale === 1) {
    data.theDayOfDeliverGoodsTime = -1
  } else if (data.preSale === 2) {
    data.promiseDeliveryTime = -1
  }
  return wxhDetailEdit(_formatGoodsItem(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
export function editWxhDetail2(data,expandParams) {
  if (data.preSale === 1) {
    data.theDayOfDeliverGoodsTime = -1
  } else if (data.preSale === 2) {
    data.promiseDeliveryTime = -1
  }
  let params = _formatGoodsItem(data, true)
  params = {
    itemInfo:{...params},
    ...expandParams
  }
  return wxhDetailEdit2(params).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取详情资料
export function getWxhDetail(baseItemId) {
  return wxhDetail({
    baseItemId
  }).then(res => {
    if (res.result === 1) {
      // debugger;
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}

// 获取类目属性
export function getCategoryProps(cid) {
  let _shopId = store.getters.shops_getCategoryPropShopId('wxsph')
  return getWxhCategoryProperties({
    shopId: _shopId,
    categoryId: cid
  }).then(res => {
    if (res.result === 1) {
      return res.data || false;
    } else {
      return false;
    }
  })
}

// 批量修改类目
export function batchWxhCategory(data) {
  return wxhBatchUpdateCategory(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
// 一键应用到其他店铺
export function ApplyToOtherShop(data) {
  return applyToOtherShop(data).then(res => {
    return res.data || {};
  })
}
// 批量填充品牌信息
export function getShopsBrandFill(data) {
  return batchBrandFill(data, '/wxsph/batchBrandFill').then(res => {
    return res.data || [];
  })
}

// 查询有效的品牌信息
export function getWxsphBrandList(data) {
  return getWxhBrandValidList(data).then(res => {
    if (res.result === 1 && res.data) {
      return res.data.brands || []
    } else {
      return []
    }
  })
}

// 批量铺货设置保存
export const saveBatchTempConfWxh = (data) => {
  return saveBatchTempConf({data,platform:'wxsph'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}
// 获取批量铺货商品详情信息
export const queryBatchDetailWxh = (data) => {
  return queryWxsphBatchProductList({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export const wxhBatchUpdateData = (data) => {
  return wxhBatchUpdate(data).then(res => {
    if(res.result === 1) {
      return true
    }
    return false
  })
}
export const wxsphBatchUpdateSkuInfo = (data) => {
  return wxsphBatchUpdateSku(data).then(res => {
    if(res.result === 1) {
      return true
    }
    return false
  })
}
// 批量铺货
export const batchPublishItemWxh = (data) => {
  return batchPublishItem({data,platform:'wxsph'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}
// 编辑视频
export const editCarouselVideo = (data) => {
  return editWxhCarouselVideo(data).then(res => {
    if (res.result === 1) {
      return res.data || null;
    }
  })
}